import {
  NameColumnDef,
  EmailColumnDef,
  AddressColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  ContactColumnDef,
  PickUpWindowColumnDef,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  cellStyle: { display: "flex", "justify-content": "center" },
  filter: true,
};

export const shipmentCarrierGrid = {
  columnDefs: [
    NameColumnDef,
    AddressColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zipcode"),
    PhoneColumnDef,
    EmailColumnDef,
    ContactColumnDef,
    PickUpWindowColumnDef,
  ],
  defaultColDef,
};
